import { HttpInterceptor, EventManager } from 'ng-jhipster';
import { RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { API_SERVER_VERSION } from '../../app.constants';

export class ErrorHandlerInterceptor extends HttpInterceptor {

    constructor(private eventManager: EventManager) {
        super();
    }

    requestIntercept(options?: RequestOptionsArgs): RequestOptionsArgs {
        return options;
    }

    responseIntercept(observable: Observable<Response>): Observable<Response> {
        return <Observable<Response>> observable.catch((error) => {
            if (!(error.status === 401 && (error.text() === '' ||
                (error.json().path && error.json().path.indexOf('/api/' + API_SERVER_VERSION + '/account') === 0 )))) {
                this.eventManager.broadcast( {name: 'marketmanagerApp.httpError', content: error});
            }
            return Observable.throw(error);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/blocks/interceptor/errorhandler.interceptor.ts